import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'

import { IPostElementProps } from '../../../../../../types/types'

interface IProps extends IPostElementProps {
  onClickDelete?: () => void
}

const CommentDelete: React.FC<IProps> = (props) => {
  return (
    <IconButton onClick={() => props.onClickDelete && props.onClickDelete()}><DeleteIcon fontSize='small' /></IconButton>
  )
}

export default CommentDelete
